import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { createStyles, Group, Text } from "@mantine/core";
const useTreeNodeStyles = createStyles({
    item: {
        listStyle: "none",
    },
    node: {
        marginBottom: "10px",
    },
});
const useTreeViewStyles = createStyles((theme, { root }) => ({
    tree: {
        padding: "0",
        ...(!root && {
            marginLeft: "8px",
            paddingLeft: "10px",
            borderLeft: `1px solid ${theme.colors.divider[0]}`,
        }),
    },
}));
const TreeNode = ({ node }) => {
    const { children, label, icon } = node;
    const { classes } = useTreeNodeStyles();
    return (_jsxs("li", { className: classes.item, children: [_jsx("div", { className: classes.node, children: _jsxs(Group, { spacing: 8, children: [icon, _jsx(Text, { size: "sm", children: label })] }) }), children && _jsx(TreeView, { treeData: children, root: false })] }));
};
const TreeView = ({ treeData, root = true, }) => {
    const { classes } = useTreeViewStyles({ root });
    return (_jsx("ul", { className: classes.tree, children: treeData.map((node) => (_jsx(TreeNode, { node: node }, node.key))) }));
};
export default TreeView;
